// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  postcode: null,
  parcelShops: [],
};

const parcelShopsReducer = createReducer(initialState, {
  // eslint-disable-next-line no-unused-vars
  [types.REQUEST_PARCEL_SHOPS](state, action) {
    return {
      ...state,
    };
  },
  [types.REQUEST_PARCEL_SHOPS_SUCCESS](state, action) {
    return {
      ...state,
      parcelShops: action.parcelShops,
    };
  },
  [types.PARCEL_SHOPS_CHANGE_FIELD](state, payload) {
    return {
      ...state,
      ...Object.assign({}, state, { [payload.field]: payload.value }),
    };
  },
  [types.SET_POSTCODE](state, action) {
    return {
      ...state,
      postcode: action.postcode,
    };
  },
});

export default parcelShopsReducer;
